import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Image } from 'components-new';
import { useState } from 'react';
import { downloadFloorPlan } from '@/components/util';

type Props = {
  tour: any;
  isDesktop: boolean;
};

export default function FloorPlans({ tour, isDesktop }: Props) {
  const [expanded, setExpanded] = useState<number | undefined>();

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    if (event.target.tagName === 'BUTTON') return;
    setExpanded(isExpanded ? panel : false);
  };

  const handleDownload = (floorPlan) => async (e) => {
    e.preventDefault();
    const url = `${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/floorplans/${floorPlan.url}`;
    await downloadFloorPlan(url, floorPlan);
  };

  return (
    <Stack spacing={2} id="floor_plans">
      {tour?.floorPlans?.map((floorPlan, index) => (
        <Accordion
          key={index}
          expanded={expanded === floorPlan.id}
          onChange={handleChangeExpanded(floorPlan.id)}
        >
          <AccordionSummary
            expandIcon={<i className="fa-regular fa-chevron-down" />}
            sx={{ px: 2 }}
          >
            <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
              <Typography sx={{ overflowWrap: 'anywhere' }}>{floorPlan.name}</Typography>
              {isDesktop ? (
                <Button
                  startIcon={<i className="fas fa-file-pdf" />}
                  sx={{ mx: 2 }}
                  onClick={handleDownload(floorPlan)}
                >
                  Download PDF
                </Button>
              ) : (
                <IconButton onClick={handleDownload(floorPlan)} sx={{ mx: 2 }}>
                  <i className="fa-solid fa-file-arrow-down" />
                </IconButton>
              )}
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Image
              ratio="16/9"
              src={`${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/floorplans/${
                floorPlan?.url?.split('.')[0]
              }.webp`}
              objectFit="contain"
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  );
}
